export default __webpack_public_path__ + "static/media/coinbase.cf31ea04.svg";